/**
 * Grup etiketi — ad verilmişse AD, verilmemişse "Grup N".
 *
 * Ad yalnız bir ETİKET: `group_no` iç anahtar olarak kalıyor (pozisyon rozetleri,
 * perp etiketleme, atama select'leri hep onunla çalışıyor). Kullanıcı kararı:
 * ad numaranın YERİNİ alsın. Bağ tamamen kopmasın diye numara `groupTitle` ile
 * üstüne gelindiğinde gösteriliyor.
 *
 * `n` (gösterilecek numara) ÇAĞIRANDAN alınıyor, çünkü yüzeyler farklı numara
 * kullanıyor: LpTrax cüzdan içi sırayı (`rank`) gösteriyor, strateji seçicisi ham
 * `no`'yu. Burada birini dayatmak, adsız grupların etiketini sessizce değiştirirdi.
 */
export function groupLabel(g: { name?: string } | null | undefined, n?: number): string {
  const nm = (g?.name || '').trim();
  if (nm) return nm;
  return n ? `Grup ${n}` : 'Grup';
}

/** Adlandırılmış grupta numarayı ipucu olarak göster; adsızda ipucu gereksiz. */
export function groupTitle(g: { name?: string } | null | undefined, n?: number): string | undefined {
  const nm = (g?.name || '').trim();
  return nm && n ? `Grup ${n}` : undefined;
}

/** Ön doldurma önerisi: grubun ilk pozisyonunun paritesi (ör. "USDC/SUI").
 *  Grup adsızken düzenlemeye basınca alan bununla açılır — tek tuşla onaylanır. */
export function groupNameSuggestion(member?: { symbolA?: string; symbolB?: string } | null): string {
  const a = (member?.symbolA || '').trim();
  const b = (member?.symbolB || '').trim();
  return a && b ? `${a}/${b}` : a || '';
}
